import classifyPoint from 'robust-point-in-polygon';

class Bullet {
    constructor(x, y) {
        this.x = x;
        this.y = y;
        this.size = 10;
        this.dead = false;

        this.bulletSpeed = width < height ? width/100 : height/100;
    }
    calculatePosition(targetX, targetY, bounds) {
        let deltaX = targetX - this.x;
        let deltaY = targetY - this.y;
        const distance = sqrt(deltaX * deltaX + deltaY * deltaY);
        deltaX /= distance;
        deltaY /= distance;

        this.x += this.bulletSpeed * deltaX;
        this.y += this.bulletSpeed * deltaY;
        const inside = classifyPoint(bounds, [this.x, this.y]);
        if(inside !== 1) {
            this.dead = true;
        }
        return this.dead;
    }
    draw(targetX, targetY, bounds) {
        const hitBlob = this.calculatePosition(targetX, targetY, bounds);
        fill(0, 255, 255);
        rect(this.x, this.y, this.size);
        return hitBlob;
    }
}

export default Bullet;